<template>
  <CommonDetail page-type="result" />
</template>
<script>
import CommonDetail from '../components/CommonDetail.vue';
export default {
  name: 'BusinessPurchaseReturnResultDetail',
  components: { CommonDetail },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {},
};
</script>
